var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"mt-3 content-vertical-aligned",staticStyle:{"display":"table"}},[_c('font-awesome-icon',{class:'tc mr-2 text-' + _vm.color,staticStyle:{"display":"table-cell"},attrs:{"icon":['fal', _vm.icon]}}),_vm._v(" "),_c('span',{staticStyle:{"display":"table-cell"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }